import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotTransportationComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotTransportation',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    d: "M17.007 9.85c-.18 0-.34-.1-.42-.27L14.682 5.5l-.06-.12A2.675 2.675 0 0 0 12.284 4H7.751c-.899 0-1.678.6-1.927 1.46l-1.099 3.9c-.08.29-.34.49-.639.49-1.098 0-2.077.9-2.077 2v4.03c0 .55.53 1 1.079 1H21c.55 0 .999-.45.999-1v-.83c0-2.76-2.237-5.2-4.993-5.2ZM12.094 6c.32 0 .62.15.81.42l1.267 2.72c.15.33-.09.71-.449.71h-6.53c-.27 0-.46-.25-.39-.51l.839-2.98c.06-.22.26-.36.48-.36h3.973Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1FDC81",
    fillRule: "evenodd",
    d: "M12.899 6.42A.98.98 0 0 0 12.09 6H8.116c-.22 0-.42.14-.48.36l-.838 2.98c-.07.26.12.51.39.51h6.53c.36 0 .599-.38.449-.71l-1.268-2.72Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    d: "M17.307 20.02a3.198 3.198 0 0 0 3.195-3.2c0-1.767-1.43-3.2-3.195-3.2a3.198 3.198 0 0 0-3.195 3.2c0 1.767 1.43 3.2 3.195 3.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M17.307 20.02a3.198 3.198 0 0 0 3.195-3.2c0-1.767-1.43-3.2-3.195-3.2a3.198 3.198 0 0 0-3.195 3.2c0 1.767 1.43 3.2 3.195 3.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    d: "M17.307 18.31c.822 0 1.488-.667 1.488-1.49a1.489 1.489 0 1 0-1.488 1.49ZM6.413 20.01a3.228 3.228 0 0 0 3.225-3.23 3.228 3.228 0 0 0-3.225-3.23 3.228 3.228 0 0 0-3.226 3.23 3.228 3.228 0 0 0 3.226 3.23Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M6.413 20.01a3.228 3.228 0 0 0 3.225-3.23 3.228 3.228 0 0 0-3.225-3.23 3.228 3.228 0 0 0-3.226 3.23 3.228 3.228 0 0 0 3.226 3.23Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    d: "M6.413 18.27c.822 0 1.488-.667 1.488-1.49a1.489 1.489 0 1 0-1.488 1.49Z"
  }));
};
SpotTransportationComponent.displayName = 'SpotTransportation';
export var SpotTransportation = withProvisionalOverrideFromContext(SpotTransportationComponent);
//# sourceMappingURL=index.js.map